import React from 'react'
import { FieldError } from 'react-hook-form'

import useStyles from './styles'

interface Props {
  message?: string | FieldError | undefined
}

const FormError: React.FC<Props> = ({ message }) => {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <span>{message}</span>
    </div>
  )
}

export default FormError
